module.exports = __webpack_public_path__ + "img/occupation-cart-head-3.15bf4b17.png";